module.exports = __webpack_public_path__ + "655d6948e91d87d7d06ab848ad3e027f.jpg";